"use client";

import { ChakraProvider, createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";
import { ColorModeProvider, type ColorModeProviderProps } from "./color-mode";


const config = defineConfig({
  theme:{
    tokens: {
      colors: {        
        primary: {value: '#0A1F44'},
        secondary: {value: '#F49038'},
        border: {value: '#E0E5EB'},
        input: {value: '#E0E5EB'},
        grey: {value: '#575555'},
      }
    }
  }
})

const system = createSystem(defaultConfig, config)

export function Provider(props: ColorModeProviderProps) {
  return (
    <ChakraProvider value={system} >
      <ColorModeProvider storageKey="droom_r_theme" enableSystem={false} {...props} />
    </ChakraProvider>
  );
}